import { AnalyticsEvents, trackEvent } from "@axqora/analytics";
import { useAppStoreHref } from "@axqora/ui";
import { screenshots } from "../assets/screenshots";
import { AppStoreButton } from "../components/AppStoreButton";
import { prismarkConfig } from "../config";
import type { LandingContent, Locale } from "../content/types";

type CtaSectionProps = {
  content: LandingContent["cta"];
  locale: Locale;
};

export function CtaSection({ content, locale }: CtaSectionProps) {
  const appStoreHref = useAppStoreHref(prismarkConfig.appStoreUrl[locale], locale);
  return (
    <section className="cta-section" id="download">
      <div className="site-container cta-card">
        <img src={screenshots.icon} alt="" width="80" height="80" loading="lazy" decoding="async" />
        <h2>{content.title}</h2>
        <p>{content.body}</p>
        <AppStoreButton
          href={appStoreHref}
          onClick={() =>
            trackEvent(AnalyticsEvents.CtaClick, {
              product: "prismark",
              page: "home",
              locale,
              target: "bottom_app_store"
            })
          }
          variant="dark"
        >
          {content.label}
        </AppStoreButton>
      </div>
    </section>
  );
}
